import {fetchData} from '@api'
import {APIMethod} from '@enums'

import {ErrorLogResponse, SuccessLogResponse} from './types'

/**
 * @returns Logs of successful actions
 */
export const getSuccessLogs = async (): Promise<SuccessLogResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: `contract/log/success`,
  })
}

/**
 * @returns Logs of errors
 */
export const getErrorLogs = async (): Promise<ErrorLogResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: `contract/log/error`,
  })
}

/**
 * @param id Company ID
 * @returns All Success Logs with a specific Company ID
 */
export const getSuccessLogsByCompany = async (id: string): Promise<SuccessLogResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: `contract/log/success/companyId/${id}`,
  })
}

/**
 * @param id Company ID
 * @returns All Error Logs with a specific Company ID
 */
export const getErrorLogsByCompany = async (id: string): Promise<ErrorLogResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: `contract/log/error/companyId/${id}`,
  })
}
